import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton';
import { themes } from './ImmersiveSlideShowControls.themes';
type Props = {
  activeIndex: number;
  className?: string;
  isNextDisabled?: boolean;
  isPaginationDisabled?: boolean;
  isPrevDisabled?: boolean;
  nextLabel?: string;
  onNext: () => void;
  onPrev: () => void;
  previousLabel?: string;
  slidesCount: number;
  theme?: keyof typeof themes;
};
export const ImmersiveSlideShowControls = ({
  activeIndex,
  className,
  isNextDisabled,
  isPrevDisabled,
  isPaginationDisabled = true,
  nextLabel,
  onNext,
  onPrev,
  previousLabel,
  slidesCount,
  theme = 'default',
}: Props) => {
  const { thRoot, thButtonColor, thPreviousButton, thNextButton, thPageIndicator } = themes[theme];
  return (
    <div className={classnames(thRoot, className)}>
      {!isPaginationDisabled && (
        <div className={thPageIndicator}>
          {activeIndex} of {slidesCount}
        </div>
      )}
      {!isPrevDisabled && (
        <ArrowButton
          className={thPreviousButton}
          color={thButtonColor}
          label={previousLabel}
          onClick={onPrev}
        />
      )}
      {!isNextDisabled && (
        <ArrowButton
          className={thNextButton}
          color={thButtonColor}
          label={nextLabel}
          onClick={onNext}
          rotation={180}
        />
      )}
    </div>
  );
};
